import { render, staticRenderFns } from "./cargoArea.vue?vue&type=template&id=13b468f0&scoped=true&"
import script from "./cargoArea.vue?vue&type=script&lang=js&"
export * from "./cargoArea.vue?vue&type=script&lang=js&"
import style0 from "./cargoArea.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./cargoArea.vue?vue&type=style&index=1&id=13b468f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b468f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b468f0')) {
      api.createRecord('13b468f0', component.options)
    } else {
      api.reload('13b468f0', component.options)
    }
    module.hot.accept("./cargoArea.vue?vue&type=template&id=13b468f0&scoped=true&", function () {
      api.rerender('13b468f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoArea.vue"
export default component.exports